import { throwErrorMsg } from "../../utils/throwErrorMsg"

export const ecr = {
  connect({
    mode, // 连接模式
    type, // 连接类型
    rate, // 波特率
    bits, // 位
    parity, // parity
    stopBits, // stopBits
    address, // 地址
    // port, // 端口号
  }) {
    throwErrorMsg("ecr.connect")
  },
  disconnect() {
    throwErrorMsg("ecr.disconnect")
  },
  register({ callback, isByte, isMix }) {
    throwErrorMsg("ecr.register")
  },
  unregister(num) {
    throwErrorMsg("ecr.unregister")
  },
  send({ msg, callback }) {
    throwErrorMsg("ecr.send")
  },
  getBlueToothAddress(fn) {
    throwErrorMsg("ecr.getBlueToothAddress")
  },
} as EcrDSL
